import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const visualTools = ['Step-by-step demonstrations', 'Large technique visuals', 'Correct vs incorrect examples', 'Process sequences', 'Ingredient and equipment setup', 'Troubleshooting', 'Student practice structures', 'Progressions', 'Evaluation tools'];
export function VisualSection() {
  return <section className="bg-blush px-4 py-20 sm:py-28" data-id="element-257" data-mp="7vp4ouan33lz">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.15fr] lg:items-center" data-id="element-258" data-mp="3p9khjbdrejjz">
        <div data-id="element-259" data-mp="3u1vsrady9rru">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-raspberry" data-id="element-260" data-mp="3u2nfdvpkkf5z">
            100% Visual
          </p>
          <h2 className="mt-3 font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-261" data-mp="3g7uqw7rpbon9">
            See the Technique Before You Teach It
          </h2>
          <p className="mt-5 text-lg leading-8 text-cocoa" data-id="element-262" data-mp="36c1firppy172">
            Pastry is visual.
            <br data-id="element-263" data-mp="3b99r29gd36zc" />
            Your teaching material should be too.
          </p>
          <p className="mt-8 border-l-2 border-raspberry pl-5 font-serif text-2xl font-semibold leading-snug text-espresso" data-id="element-264" data-mp="eqiww2sjhcln">
            <span className="text-raspberry" data-id="element-265" data-mp="9rz7fseqlioj">100% visual</span> material created
            for real pastry classes.
          </p>
        </div>
        <div className="rounded-2xl border border-champagne bg-cream-light p-6 sm:p-8" data-id="element-266" data-mp="jqy7wnpcm80g">
          <h3 className="text-xs font-bold uppercase tracking-[0.13em] text-cocoa" data-id="element-267" data-mp="3s6hx9bmwf6a8">
            Pastry Instructor Ready includes
          </h3>
          <ul className="mt-5 grid gap-x-8 gap-y-3.5 sm:grid-cols-2" data-id="element-268" data-mp="3n8gekrtdx8za">
            {visualTools.map(item => <li key={item} className="flex gap-2.5 text-sm font-medium leading-6 text-espresso" data-id="element-269" data-mp="4uz2jktmilz0">
                <CheckCircle2Icon size={17} className="mt-0.5 shrink-0 text-champagne-deep" aria-hidden="true" data-id="element-270" data-mp="38ihgsq5qrzkc" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}